import marqueeStyle from './AutoPlayCarousle.module.scss';
import { marqueeTech } from '../../data/skills';

/**
 * Seamless technology ticker. The list is rendered twice so the track can
 * loop by translating exactly -50% with no visible seam.
 */
const AutoPlayCarousle = () => {
    const loop = [...marqueeTech, ...marqueeTech];

    return (
        <div className={marqueeStyle.marquee} aria-hidden='true'>
            <div className={marqueeStyle.track}>
                {loop.map((tech, i) => (
                    <span key={i} className={marqueeStyle.item}>
                        <span className={marqueeStyle.dot} style={{ backgroundColor: tech.color }} />
                        {tech.label}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default AutoPlayCarousle;
